// Consistent sex styling. Soft-tinted avatars (a light wash behind a coloured
// icon) match the app's icon-tile visual language and read as more refined
// than solid vivid circles.

const SEX_TINTS = {
  male: { bg: 'rgba(47,127,209,0.11)', color: '#2f7fd1' },
  female: { bg: 'rgba(207,61,129,0.11)', color: '#cf3d81' },
  unknown: { bg: 'rgba(107,118,136,0.12)', color: '#5b6675' }
};

/** sx for an MUI Avatar tinted by sex. */
export const sexAvatarSx = (sex) => {
  const t = SEX_TINTS[sex] || SEX_TINTS.unknown;
  return { bgcolor: t.bg, color: t.color };
};

export default sexAvatarSx;
